import { createApi } from '@reduxjs/toolkit/query/react';
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { transformRequest } from '../../utils/API/requestMiddleware';
import { transformErrorResponse, transformSuccessResponse } from '../../utils/API/responseMiddleware';

const projectComponentAPI = createApi({
    reducerPath: "projectComponentAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        getAllProjectComponent: builder.query({
            query: () => ({
                url: `/ProjectDetailsManagement/GetAllProjectComponent`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getProjectComponentList: builder.mutation({
            query: (data) => ({
                url: "/ProjectDetailsManagement/GetProjectComponentList",
                method: "POST",
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        addProjectComponent: builder.mutation({
            query: (data) => ({
                url: `/ProjectDetailsManagement/AddProjectComponent`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteProjectComponent: builder.mutation({
            query: (ProjectComponentId) => ({
                url: `/ProjectDetailsManagement/DeleteProjectComponent?id=${ProjectComponentId}`,
                method: 'DELETE',
                body: transformRequest(ProjectComponentId)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getProjectComponentById: builder.query({
            query: (ProjectComponentId) => ({
                url: `/ProjectDetailsManagement/GetProjectComponentDetailsByID/?id=${Number(ProjectComponentId)}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateProjectComponent: builder.mutation({
            query: (data) => ({
                url: '/ProjectDetailsManagement/UpdateProjectComponent',
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

    })
})

export const {
    useLazyGetAllProjectComponentQuery,
    useGetProjectComponentListMutation,
    useAddProjectComponentMutation,
    useDeleteProjectComponentMutation,
    useLazyGetProjectComponentByIdQuery,
    useUpdateProjectComponentMutation
} = projectComponentAPI;

export default projectComponentAPI